import React, { useState } from 'react';
import './AvatarPicker.css';

const AVATAR_PACKS = {
  default: {
    label: 'Default',
    prefix: 'Avatar_',
    folder: 'default',
    count: 15
  },
  malayalam: {
    label: 'Malayalam',
    prefix: 'Mal_',
    folder: 'malayalam',
    count: 17
  }
};

export default function AvatarPicker({ currentAvatar, takenAvatars = [], onSelect, onClose }) {
  const [activeTab, setActiveTab] = useState(() => {
    if (currentAvatar && currentAvatar.startsWith('Mal_')) return 'malayalam';
    return 'default';
  });

  const pack = AVATAR_PACKS[activeTab];
  const availableAvatars = Array.from({ length: pack.count }, (_, i) => `${pack.prefix}${i + 1}`);

  const safeTakenAvatars = Array.isArray(takenAvatars) ? takenAvatars : [];
  const safeCurrentAvatar = currentAvatar || '';

  return (
    <div className="avatar-modal-overlay">
      <div className="avatar-modal-content glass-panel">
        <div className="modal-header">
          <h2 className="panel-title" style={{ margin: 0 }}>Choose Your Persona</h2>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>

        <div className="avatar-tabs">
          {Object.entries(AVATAR_PACKS).map(([id, config]) => (
            <button 
              key={id}
              className={`avatar-tab-btn ${activeTab === id ? 'active' : ''}`}
              onClick={() => setActiveTab(id)}
            >
              {config.label}
            </button>
          ))}
        </div>

        <div className="avatar-grid">
          {availableAvatars.map(avatarId => {
            const isTaken = safeTakenAvatars.includes(avatarId) && avatarId !== safeCurrentAvatar;
            const isCurrent = avatarId === safeCurrentAvatar;

            return (
              <div 
                key={avatarId}
                className={`avatar-choice ${isTaken ? 'locked' : ''} ${isCurrent ? 'selected' : ''}`}
                onClick={() => {
                  if (!isTaken) {
                    onSelect(avatarId);
                    onClose();
                  }
                }}
              >
                <img 
                  src={`${process.env.PUBLIC_URL || ''}/assets/avatars/${pack.folder}/${avatarId}.webp`} 
                  alt={`Persona ${avatarId}`} 
                />

                {isTaken && <div className="taken-stamp">TAKEN</div>}
                {isCurrent && <div className="current-stamp">ACTIVE</div>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}